import React from 'react';
import styled from 'styled-components/macro';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slide from './Slide';

const StyledSlider = styled(Slider)`
  width: 100%;

  & > .slick-dots {
    position: relative;
    bottom: 0;
  }
`;

const I = styled.i`
  opacity: 0.7;
`;

const ArrowWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  height: 100%;
  top: 50%;
  transform: translate(0, -50%);
  display: ${props => (props.disabled ? 'none' : 'flex')};
  z-index: 100;
  background-color: ${props => props.theme.research.backgroundColor};
  align-items: center;
`;

const PrevArrow = ({ className, onClick }) => {
  const disabled = /disabled/.test(className);
  return (
    <ArrowWrapper onClick={onClick} disabled={disabled}>
      <I className="fas fa-chevron-left fa-2x"></I>
    </ArrowWrapper>
  );
};

const NextArrowWrapper = styled(ArrowWrapper)`
  right: 0;
`;

const Quotes = styled.div`
  font-size: 6em;
  font-family: serif;
  opacity: 0.5;
`;

const NextArrow = ({ className, onClick }) => {
  const disabled = /disabled/.test(className);
  return (
    <NextArrowWrapper onClick={onClick} disabled={disabled}>
      <I className="fas fa-chevron-right fa-2x"></I>
    </NextArrowWrapper>
  );
};

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    // Custom Arrows
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    // Custom Dots
    appendDots: dots => {
      return (
        <div style={{ marginTop: 24 }}>
          {dots.map((dot, i) => {
            const active = /active/.test(dot.props.className);
            return (
              <li key={i} onClick={dot.props.children.props.onClick}>
                <i
                  className={
                    active ? 'fas fa-circle fa-sm' : 'far fa-circle fa-sm'
                  }
                ></i>
              </li>
            );
          })}
        </div>
      );
    },
  };

  return (
    <React.Fragment>
      <Quotes>&#8220;</Quotes>

      <StyledSlider {...settings}>
        <Slide source="Dr. Jo Boaler, Mathematical Mindsets">
          <i>Wuzzit Trouble</i> helps students gain an understanding of
          important mathematics - adding and subtracting, factors and multiples
          - at the same time as they develop number flexibility and
          problem-solving strategies.
        </Slide>
        <Slide source="Junaid Mubeen, Medium">
          Wuzzit Trouble represents gaming from start to finish and . . .subtly
          embeds elements of problem solving, number sense and linear algebra.
        </Slide>
        <Slide source="Ruth Hrebinka, Teacher, Springfield, VA">
          I am a 6th grade teacher teaching 7th grade math to advanced students.
          I have never seen my students so engaged and excited.
        </Slide>
        <Slide source="Jordan Shapiro, Forbes">
          I’m excited to let my kids play Wuzzit Trouble (and to play it
          myself!). The game fulfills one of the great promises of game-based
          learning: the ability for a game to teach multiple skills
          simultaneously.
        </Slide>
        <Slide source="Marie Bjerede, “Learning in the Digital Age,” EducationNext">
          My kids spent hours trying to beat this game. . .Even their
          grandmother played. Pay attention app developers — this is the future
          of edugaming.
        </Slide>
        <Slide source="Peter Norvig, Director of Research, Google">
          BrainQuake provides an exceptional foundation for future coding
          success. BrainQuake helps develop the conceptual mathematical thinking
          and problem-solving skills that are essential for excellent software
          engineers and other important technical fields.
        </Slide>
        <Slide source="J.Alison Bryant, Ph.D., CEO & Chief Play Officer, PlayScience Lab">
          The team at BrainQuake is setting the standard for the next generation
          of educational media. Their integration of rigorous science
          underpinnings with intrinsically motivating play creates the kind of
          engaging and impactful learning experience for which we should all be
          striving.
        </Slide>
        <Slide source="Greg Toppo, The Game Believes in You: How Digital Play Can Make Our Kids Smarter">
          “To succeed in Wuzzit Trouble, you have to practice. . .When you come
          up with a complex solution, all you really want to do is see it again
          and show it to your friends. Watch this, you say. It is a performance.
        </Slide>
      </StyledSlider>
    </React.Fragment>
  );
};

export default Carousel;
